import React from 'react';
import classnames from 'classnames';
import ErrorsHigherOrderComponent from '../ErrorsHigherOrderComponent';

export default class InputTextWithErrors extends ErrorsHigherOrderComponent{
  render () {
    const { className, errors, ...others } = this.props;
    const inputClassNames = classnames({
      className,
      'can-has-errors': 'errors' in this.props,
      'has-errors': (Array.isArray(errors) && errors.filter(error => error).length) || (typeof errors === 'string' && errors.length),
    });
    return (
      <div className={inputClassNames}>
        <input type="text"
          {...others}
          />
        {
          errors
          ? this.getErrorsBlock(errors)
          : null
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/views/form/InputTextWithErrors.js